import styled from 'styled-components'

export const SCFullscreenOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100dvh;
  background: white;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
